import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TasksComponent } from './modules/tasks/tasks.component';
import { RightType } from './services/enums/rightType';
import { AuthGuard } from './services/guards/auth-guard.service';
import { UnauthorizedComponent } from './shared/components/unauthorized/unauthorized.component';

const routes: Routes = [
  {
    path: 'tasks',
    component: TasksComponent,
    loadChildren: () =>
      import('./modules/tasks/tasks.module').then((m) => m.TasksModule),
    canActivate: [AuthGuard],
    data: { rights: [RightType.tasksCanSeeTasks] },
  },
  {
    path: 'customers',
    loadChildren: () =>
      import('./modules/customers/customers.module').then(
        (m) => m.CustomersModule
      ),
    canActivate: [AuthGuard],
    data: { rights: [RightType.customersCanSeeCustomers] },
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('./modules/admin/admin.module').then((m) => m.AdminModule),
    canActivate: [AuthGuard],
    data: { rights: [RightType.adminCanSeeAdminPage] },
  },
  {
    path: 'system_logs',
    loadChildren: () =>
      import('./modules/system-logs/system-logs.module').then(
        (m) => m.SystemLogsModule
      ),
    canActivate: [AuthGuard],
    data: { rights: [RightType.adminCanSeeSystemLogs] },
  },
  { path: 'unauthorized', component: UnauthorizedComponent },
  {
    path: '**',
    component: UnauthorizedComponent,
    canActivate: [AuthGuard],
    data: { rights: [] },
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
